/*
    © 2021 EcomGraduates.com
    https://www.ecomgraduates.com
*/

// const hiddenCollectionHandles = ['dry-low', 'dry-high', 'oily-low', 'oily-high', 'combination-low', 'combination-high', 'sensitive-low', 'sensitive-high', 'normal-low', 'normal-high', 'breakouts-and-blemishes', 'hyperpigmentation', 'fine-lines-and-wrinkles', 'rosacea-or-redness', 'results-all', '']
const visibleCollectionHandles = ['all-skincare', 'skincare', 'all-beauty', 'beauty', 'custom-bundle', 'all-products', 'all', 'new-arrivals', 'member-favorites', 'cleansers', 'serums', 'eyes', 'lips', 'perfume', 'colognes', 'anti-aging-1', 'moisturizers', 'beauty-bundles', 'wellness-2', 'wellness']

// Focus on search input on offcanvas open
document.querySelector('#offcanvas-search').addEventListener('shown.bs.offcanvas', () => {
    document.querySelector('#offcanvas-search input[name="q"]').focus()
})

function debounce(func, wait = 20, immediate = true) {
    let timeout
    return function() {
        const context = this, args = arguments
        const later = function() {
            timeout = null
            if (!immediate) func.apply(context, args)
        }
        const callNow = immediate && !timeout
        clearTimeout(timeout)
        timeout = setTimeout(later, wait)
        if (callNow) func.apply(context, args)
    }
}

// Handle Predictive Search
document.querySelectorAll('.predictive-search-input').forEach((input) => {
    input.addEventListener('input', window.debounce((e) => {
        const form = e.target.closest('form')
        const value = e.target.value
        const results = form.querySelector('.predictive-search-results')
        const clearBtn = form.querySelector('.btn-clear')
        const upsells = document.querySelector('#offcanvas-search-upsell-collection-wrapper')

        if (value.length === 0) {
            results.classList.remove('show')
            clearBtn.classList.remove('show')
            upsells.classList.add('hide')
            input.setAttribute('aria-expanded', 'false')
        } else {
            const {
                textOldPrice,
                textPriceFrom,
                textViewAllResults,
                textTitleCollections,
                textTitleProducts,
                textTitlePages,
                textTitleBundles
            } = results.dataset

            const url = `/search/suggest.json?q=${value}&resources[type]=product,collection,page&resources[limit]=15&resources[options][unavailable_products]=show&resources[options][fields]=tag,title,variants.title,body`

            fetch(url)
                .then((response) => response.json())
                .then((data) => {
                    const { collections, products, pages } = data.resources.results

                    if (products.length || collections.length || pages.length) {
                        let collectionListItems = ''
                        let productListItems = ''
                        let bundleListItems = ''
                        let pagesListItems = ''

                        let collectionLength = 0
                        collections.forEach((collection) => {

                            if (visibleCollectionHandles.includes(collection.handle)) {
                                collectionListItems += `
                                    <li class="p-2">
                                        <a 
                                            href="${collection.url}" 
                                            class="btn btn-outline-dark btn-sm py-1">
                                            ${collection.title}
                                        </a>
                                    </li>
                                `

                                collectionLength += 1;
                            }
                        })

                        products.forEach((product) => {
                            productListItems += `
                                    <li class="product-list-item py-2">
                                        <a href="${product.url}" class="text-decoration-none text-dark d-block">
                                            <div class="d-flex align-items-center bg-white py-0">
                                                <img 
                                                    class="product-img img-fluid me-4"
                                                    src="${window.resizeImage(product.featured_image.url || 'no-image.gif', '110x110', 'center')}"
                                                    alt="${product.featured_image.alt}" 
                                                    width="110"
                                                    height="110"
                                                    loading="lazy">
                                                <div>
                                                <div class="yotpo bottomLine mb-2" data-product-id="${product.id}"></div>
                                                <h5 class="product-title h6 small mb-2">
                                                        ${product.title}
                                                    </h5>
                                                    <p class="product-price mb-1">
                                                        <s class="product-price-compare text-secondary me-1 ${product.compare_at_price_min > 0 ? '' : 'd-none'}">
                                                            <span class="visually-hidden">
                                                                ${textOldPrice}
                                                            </span>
                                                            ${window.formatMoney(product.compare_at_price_min)}
                                                        </s>
                                                        <span class="product-price-final">
                                                            <span class="product-price-from ${product.price_min !== product.price_max ? '' : 'd-none'}">
                                                                ${textPriceFrom}
                                                            </span>
                                                            ${window.formatMoney(product.price)}
                                                        </span>
                                                    </p>
                                                </div>
                                            </div>
                                        </a>
                                    </li>
                                `
                        }
                        )

                        pages.forEach((page) => {
                            pagesListItems += `
                                <li class="p-2">
                                    <a 
                                        href="${page.url}" 
                                        class="btn btn-outline-dark btn-sm py-1">
                                        ${page.title}
                                    </a>
                                </li>
                            `
                        })

                        results.innerHTML = `
                            <div class="predictive-search-collection-list ${collectionLength ? '' : 'd-none'}">
                                <h4 class="title h6 small text-uppercase mt-3 mb-3">
                                    ${textTitleCollections}
                                </h4>
                                <ul class="collection-list list-unstyled d-flex flex-wrap mx-0 mt-2 mb-7 mx-n2">
                                    ${collectionListItems}
                                </ul>
                            </div>
                            <div class="predictive-search-product-list ${products.length ? '' : 'd-none'}">
                                <h4 class="title h6 small text-uppercase mt-3 mb-3">
                                    ${textTitleProducts}
                                </h4>
                                <ul class="product-list list-unstyled mt-2 mb-6">
                                    ${productListItems}
                                </ul>
                            </div>
                            <div class="predictive-search-pages-list ${pages.length ? '' : 'd-none'}">
                                <h4 class="title h6 small text-uppercase mt-3 mb-3">
                                    ${textTitlePages}
                                </h4>
                                <ul class="collection-list list-unstyled d-flex flex-wrap mx-0 mt-2 mb-7 mx-n2">
                                    ${pagesListItems}
                                </ul>
                            </div>
                            <hr class="mt-0 d-none">
                            <div class="pb-2 d-none">
                                <button type="submit" class="btn btn-sm w-100 btn-primary">
                                    ${textViewAllResults}
                                </button>
                            </div>
                        `

                        if (window.Yotpo) {
                            const api = new Yotpo.API(yotpo)
                            api.refreshWidgets()
                        }

                        results.classList.add('show')
                        clearBtn.classList.add('show')
                        upsells.classList.add('hide')
                        input.setAttribute('aria-expanded', 'true')
                    } else {
                        results.classList.remove('show')
                        input.setAttribute('aria-expanded', 'false')
                    }
                })
        }
    }))
})

// Handle Clear button
document.querySelectorAll('#offcanvas-search .btn-clear').forEach((btn) => {
    btn.addEventListener('click', (e) => {
        btn.classList.remove('show')
        btn.closest('form').querySelector('input[name="q"]').value = ''
        btn.closest('form').querySelector('.predictive-search-results').classList.remove('show')
        document.querySelector('#offcanvas-search-upsell-collection-wrapper').classList.remove('hide')
    })
})


// Offcanvas search - Open it if URL contains '#search'

if (window.location.hash.includes('#search')) {
    const offcanvasCart = bootstrap.Offcanvas.getOrCreateInstance('#offcanvas-search')
    offcanvasCart.show()
}

// Do not open the search page from the offcanvas cart
document.querySelectorAll('form[action="/search').forEach((form) => {
    form.addEventListener('submit', (e) => {
        e.preventDefault()
    })
})
